
import { post } from "../Axios/Axios"

// import { reportError } from "./commonServices";

export function reportError(){
    return {
      status: false,
      message: "Something went wrong"
    }
  }


// export function CheckUser(aadhaar, callback){

    

//     let req = {
//         "aadhar":aadhaar, 
        
//     }
//     post("/public/check-user", req , 0).then((res)=>{

    
//         if(res){
            
//             callback(res)
//         }else{
            
//             callback(reportError())
//         }
//     })

// }


export function addAdminUser(req, callback){

    

    // let req = {
    //    "userId":userId
        
    // }
    post("/citizen/sso-dept-user-create", req , 1).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

export function userType(req1, callback){

    

    let req = {
      
       "domainCode":req1
        
    }
    post("/citizen/user-types", req , 1).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

export function viewUser(req, callback){

    

  
    post("/citizen/view-user", req , 1).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

export function adminUserDomainDetails(req, callback){

    

   
    post("/public/domain-details", req , 1).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

export function exitingAdminDomainList(req, callback){

    

    // let req = {
    //    "userId":userId
        
    // }
    post("/citizen/created-by", req , 1).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

export function addDesignation(req, callback){

    

   
    post("/public/save-designation", req , 0).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

export function consumerIdSentOtp(req, callback){

    

   
    post("/public/fetch-consumerid-send-otp", req , 0).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

export function panCardSendOtp(req, callback){

    

   
    post("/public/link-pan-user", req , 0).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

export function medicalCardSendOtp(req, callback){

    

   
    post("/public/fetch-medicalcardno-send-otp", req , 0).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}


export function updateMedicalCardNumber(req, callback){

    

   
    post("/public/save-opd-cardNo", req , 0).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

export function loggedInUserDetails(req, callback){

    

   
    post("/public/save-logined-userDetail", req , 0).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}

// export function verifyLoginOtp(mobNo,otp, callback){

//     let otpReq={
//         "mobileNumber":mobNo,
//         "otp": otp,
//          "optLogin":"1"
//     }

//     post("/public/verify-otp",otpReq,0).then((res)=>{

//         if(res){
  
//             callback(res);
//         }
//         else{
//             callback(reportError());
//         }
//     })

// }


export function verifyLoginOtp(mobNo,otp,username, callback){

    let otpReq={
        "mobileNumber":mobNo,
        "otp": otp,
        "username":username
    }

    post("/otp-login",otpReq,0).then((res)=>{

        if(res){
  
            callback(res);
        }
        else{
            callback(reportError());
        }
    })

}


export function multipleUserOtp(mobNo, callback){

    let req={
         "input":mobNo
    }

    post("/public/sendOtp-multipleUsers", req , 0).then((res)=>{

    
        if(res){
            
            callback(res)
        }else{
            
            callback(reportError())
        }
    })

}




